/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Hands1(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Hands1.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Hands1.geometry}
        material={materials.Red}
        position={[-0.78, 125.3, 0]}
      >
        <meshPhysicalMaterial
          color={colorArr[4]}
          reflectivity={1}
          roughness={0.8}
        />
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/Hands1.glb')
